module.exports = __webpack_public_path__ + "preset.8abc782e873655b023d523a1c9c979d4.png";